"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AirwebTicketLegacyProductsService = void 0;
class AirwebTicketLegacyProductsService {
    constructor(client) {
        this.client = client;
    }
    async getUniversalProducts(networkId, lang = null, type = null, options = {}) {
        const response = (await this.client.http
            .get('Products/getUniversalProducts.json', Object.assign(Object.assign({}, options), { params: { network_id: networkId, lang, type } }))
            .catch(this.handleError));
        return response.data.productType;
    }
    async getProducts(query = {}, options = {}) {
        const response = (await this.client.http
            .get('Products/getProducts.json', Object.assign(Object.assign({}, options), { params: query }))
            .catch(this.handleError));
        return response.data.productType;
    }
    async getProductType(productTypeId, query = {}, options = {}) {
        const response = (await this.client.http
            .get('Products/getProducts.json', Object.assign(Object.assign({}, options), { params: query }))
            .catch(this.handleError));
        return response.data.productType.find((productType) => productType.productTypeId === productTypeId);
    }
    async getProduct(productId, query = {}, options = {}) {
        const response = (await this.client.http
            .get('Products/getProducts.json', Object.assign(Object.assign({}, options), { params: query }))
            .catch(this.handleError));
        for (const productType of response.data.productType) {
            for (const product of productType.shopItem) {
                if (product.shopItemId === productId) {
                    return product;
                }
            }
        }
        return undefined;
    }
    async media(userToken, query, options = {}) {
        const { data } = await this.client.http.get('Products/media', Object.assign({ params: Object.assign({ userToken }, query) }, options));
        return data;
    }
    handleError(error) {
        throw error;
    }
}
exports.AirwebTicketLegacyProductsService = AirwebTicketLegacyProductsService;
//# sourceMappingURL=products.service.js.map